module.exports = __webpack_public_path__ + "img/opensea.bfc0e18b.svg";